// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_pop .select_empty{padding:10px 0;margin:0;text-align:center;color:#999;font-size:14px}.my-sel-empty__data{color:#666;padding:30px 0}", ""]);
// Exports
module.exports = exports;
